export const uploadPhoto = {
  success: true,
  fname: "neocities5",
  ext: "png",
  url: "https://s3-us-west-2.amazonaws.com/dev-photos.flocknote.com/neocities5/original.png",
  s3: true,
  photoID: 123,
  userID: 2,
};
